import { LitElement, html, css } from 'lit-element';
import { connect } from '../store/connect';
import { selectors } from './';
import { selectors as routeSelectors } from '../routing';
import '../routing/routed-link';
import './navigation-menu-mobile';

class NavigationMneu extends LitElement {
    constructor() {
        super();
    }

    static get properties() {
        return {
            isMobile: {
                type: Boolean,
            },
            route: {
                type: String,
            },
            routes: {
                type: Array,
            },
        };
    }

    static get styles() {
        return css`
            :host {
                display: flex;
                font-size: 1.1em;
            }
        `;
    }

    render() {
        const { routes, route, isMobile } = this;
        if (isMobile) {
            return this.renderMobile();
        }
        return routes.map(
            ({ name, data, displayKey }, idx) => html`<routed-link .data=${data} .name=${name}
                    >${displayKey}</routed-link
                >
                ${idx < routes.length - 1 ? html` <span>&nbsp;|&nbsp;</span> ` : null}`
        );
    }

    renderMobile() {
        const { routes, route, isMobile } = this;
        return html`<navigation-menu-mobile
            .route=${route}
            .routes=${routes}></navigation-menu-mobile>`;
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        return {
            isMobile: selectors.isMobile(state),
            route: routeSelectors.currentRouteName(state),
            routes: selectors.authorizedNavRoutesSelector(state),
        };
    };
};

window.customElements.define('navigation-menu', connect(mapStateToProps)(NavigationMneu));
